$( window ).on( "load", function() {
	let formContainer = $( ".job-application__form" );

	if ( $( formContainer ).length ) {
		formContainer.addClass( "show" );
	}
	setTimeout( function() {
		let breadcrumbs = $( ".nf-breadcrumbs .nf-breadcrumb" );
		let totalSteps = breadcrumbs.length;

		let stepsCountElement = $( ".job-application__form--steps .steps-count-js" );
		let totalStepsElement = $( ".job-application__form--steps .steps-total-js" );

		totalStepsElement.text( totalSteps );
		stepsCountElement.text( "1" );

	}, 300 );

	function stepNumber() {
		$( ".steps-count-js" ).text( $( ".nf-breadcrumbs .active" ).index() + 1 );
	}

	let $saveFormBtn = $( ".save-form-btn" );

	setTimeout( function() {
		$saveFormBtn.appendTo( $( ".nf-mp-footer" ) );
	}, 200 );
	
	$( document ).on( "change", ".job-form form :input", function() {
		let formData = JSON.parse( localStorage.getItem( "form_data" ) ) || {};
		$( ".job-form form :input" ).each( function() {
			if ( $( this ).is( ":checkbox" ) ) {
				let checkboxName = $( this ).attr( "name" );
				if ( !formData[checkboxName] ) {
					formData[checkboxName] = [];
				}
				if ( $( this ).prop( "checked" ) ) {
					formData[checkboxName].push( $( this ).val() );
				}
			} else if ( $( this ).is( ":radio" ) ) {
				if ( $( this ).is( ":checked" ) ) {
					formData[this.name] = $( this ).val();
				}
			} else {
				formData[this.name] = $( this ).val();
			}
		} );
		localStorage.setItem( "form_data", JSON.stringify( formData ) );
	} );

	function simulateCheckboxClick(checkbox) {
		if (!checkbox.prop( "checked" ) ) {
			checkbox.prop( "checked", true );
			checkbox.addClass( "nf-checked" );
			checkbox.trigger( "change" );
		}
	}
	
	function savedData() {
		let savedData = localStorage.getItem( "form_data" );
		let formSaved = localStorage.getItem("form_data_saved");
		if (savedData && formSaved === "true") {
			savedData = JSON.parse( savedData );
			setTimeout( function() {
				$.each( savedData, function( name, value ) {
					let $input = $( '[name="' + name + '"]' );
					if ( value !== '' && value !== null && value !== undefined ) {
						if ( $input.is( ':checkbox' ) ) {
							if ( Array.isArray( value ) ) {
								value.forEach( function( val ) {
									simulateCheckboxClick( $('[name="' + name + '"][value="' + val + '"]') );
								});
							}
						} else if ( $input.is( ":radio" ) ) {
							simulateCheckboxClick($('[name="' + name + '"][value="' + value + '"]'));
						} else {
							$input.val( value ).parent().prev().addClass( "active" );
						}
					}
				} );
			}, 300 );
		}
	}
	
	$(".save-form-btn span").on("click", function() {
		localStorage.setItem("form_data_saved", "true");
	});

	$( document ).on( "click", ".nf-breadcrumb, .nf-previous, .nf-next", function( event ) {
		event.preventDefault();
		stepNumber();
		savedData();
		$( ".job-form form :input" ).parent().prev().addClass( "active" );
	} );
	
	savedData();

	let formSaved = localStorage.getItem( "form_data_saved" );
	if ( formSaved !== "true" ) {
		localStorage.setItem( "form_data_saved", "false" );
	}

	$( document ).on( "nfFormSubmitResponse", function( e, response, id ) {
		if ( $( ".job-form" ).length ) {
			localStorage.removeItem( "form_data" );
			localStorage.removeItem( "form_data_saved" );
		}
	} );
} );